import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { HomeComponent } from './home.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { HelpPageComponent } from './pages/help-page/help-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { OnboardingPageComponent } from './pages/onboarding-page/onboarding-page.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';
import { ExternalLinksPageComponent } from './pages/external-links-page/external-links-page.component';
const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        children: [
            { path: 'policies', component: TermsOfUseComponent, canActivate: [AuthGuard] },
            { path: 'contact', component: ContactUsComponent, canActivate: [AuthGuard] },
            { path: 'help', component: HelpPageComponent, canActivate: [AuthGuard] },
            {
                path: 'externalLinks',
                data: {
                    title: 'community.nav.theme.externalLinkTitle',
                },
                component: ExternalLinksPageComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'onboarding',
                component: OnboardingPageComponent,
            },
            {
                path: '',
                data: {
                    title: 'navMenu.welcomeTitle',
                },
                component: HomePageComponent,
                canActivate: [AuthGuard],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class HomeRoutingModule {}
